import { useDispatch, useSelector } from 'react-redux';
import { changeFormParams } from 'store/dealManagement/reducer';
import { Store } from 'components/common/types/Store.types';

export const useOnDspInUse = (): { onDspInUse: (dspInUseCallback: () => void) => void } => {
  const dispatch = useDispatch();
  const dspIsLegacy = useSelector((state: Store) => state.dealManagement.programmatic.dspIsLegacy);

  const onDspInUse = (dspInUseCallback: () => void): void => {
    if (dspIsLegacy) {
      dispatch(changeFormParams({ isDspNoLongerInUseDialogVisible: true }));
      return;
    }

    dspInUseCallback();
  };

  return { onDspInUse };
};
